<div class="ai-message" [ngClass]="message.sentBy">
  <div class="user-avatar">
    <ng-container *ngTemplateOutlet="userTemplate"></ng-container>
  </div>

  <div class="content">
    <ng-container *ngFor="let item of message.content">
      <ng-container *ngTemplateOutlet="contentTemplate; context: item"></ng-container>
    </ng-container>

    <ng-content></ng-content>
  </div>
</div>

<ng-template #contentTemplate let-type="type" let-value="value">
  <div [ngClass]="type">
    <ai-chat-image *ngIf="type === 'image_file'" [fileId]="value"></ai-chat-image>

    <ng-container *ngIf="['text', 'error'].includes(type)">
      <ng-container *ngIf="!!value; else answerInProgress">
        <div class="answer" [innerHTML]="value | transform: textToHtml.bind(this)"></div>
      </ng-container>
    </ng-container>
    <ng-template #answerInProgress>
      <div class="loading">{{ assistantName }} is typing</div>
    </ng-template>
  </div>
</ng-template>

<ng-template #userTemplate>
  <ng-container *ngIf="message.sentBy === 'user'; else aiAssistantTemplate">
    <div *ngIf="!user.avatar_md" class="avatar-img">{{ user | transform: getInitials }}</div>
    <img [alt]="user.email" *ngIf="user.avatar_md" class="avatar-sm" [src]="user.avatar_md" />
  </ng-container>

  <ng-template #aiAssistantTemplate>
    <mat-icon svgIcon="ai-avatar" class="avatar-sm"></mat-icon>
  </ng-template>
</ng-template>
